import { render, staticRenderFns } from "./ModalReordenarDocumento.vue?vue&type=template&id=3f94ee36&scoped=true"
import script from "./ModalReordenarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalReordenarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalReordenarDocumento.vue?vue&type=style&index=0&id=3f94ee36&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f94ee36",
  null
  
)

export default component.exports